var themes = {};

themes.init = function() {

  /* Canonical theme list — kept in sync with settingsMenu.js's Themes tab
     (which redefines the same global later; this copy builds the NAV select,
     so it must already be complete when themes.init() runs). Clear was removed
     2026-08-17 (redundant with Default) — its leftover entry here made the nav
     dropdown a dead Default/Clear pair. */
  themes.themes = [ {
    label : 'Dark Reader',
    id : 'darkreader'
  }, { label : 'Tomorrow (Night)', id : 'tomorrow' }, {
    label : 'Green',
    id : 'green'
  }, { label : 'Yotsuba B', id : 'yotsubaB' }, {
    label : 'Catppuccin Mocha',
    id : 'catppuccin'
  } ];

  for (var i = 0; i < themes.themes.length; i++) {
    // Guard on .file: the canonical list entries have no file property (themes
    // switch via themeLoader.load() + body class), and unguarded this built a
    // dead '/.static/css/undefined' stylesheet link per entry (404 noise).
    if (!themes.themes[i].file) { continue; }
    themes.themes[i].element = document.createElement('link');
    themes.themes[i].element.type = 'text/css';
    themes.themes[i].element.rel = 'stylesheet';
    themes.themes[i].element.href = '/.static/css/' + themes.themes[i].file;
  }

  if (api.boardUri) {

    var linkedCss = document.getElementsByTagName('link');

    for (var i = 0; i < linkedCss.length; i++) {

      var ending = '/' + api.boardUri + '/custom.css';

      if (linkedCss[i].href.indexOf(ending) === linkedCss[i].href.length
          - ending.length) {
        themes.customCss = linkedCss[i];
        break;
      }
    }

  }

  // themes.updateCss();

  var navStart = document.getElementById('navStart');

  if (navStart) {

    // The select is STATIC markup (rightBar*.njk, before the options span)
    // since 2026-09 — it used to be created + inserted HERE after first paint,
    // growing the nav's right side ~100px on every load. Wire the existing
    // element; create + insert only as a fallback for a page without the
    // template markup. (The ' / ' divider it used to dangle is static in the
    // templates now too.)
    var themeSelector = document.getElementById('themeSelector');
    if (!themeSelector) {
      // Fallback (template markup absent): build the SAME structure the
      // rightBar*.njk templates ship — a .themeSelectWrap span around the select.
      // The wrapper is what the mobile nav CSS paints the brush glyph on, so a
      // bare unwrapped select would lose its icon + fixed width on <=767px.
      var wrap = document.createElement('span');
      wrap.className = 'themeSelectWrap';
      themeSelector = document.createElement('select');
      themeSelector.id = 'themeSelector';
      wrap.appendChild(themeSelector);
      navStart.parentNode.insertBefore(wrap, navStart.nextSibling);
    }

    // The static template markup ships the same option list (so the select has
    // its final width from frame 1) — clear it before populating for real, or
    // every option would be duplicated.
    while (themeSelector.firstChild) {
      themeSelector.removeChild(themeSelector.firstChild);
    }

    var vanillaOption = document.createElement('option');
    vanillaOption.innerHTML = 'Default';
    themeSelector.appendChild(vanillaOption);

    for (var i = 0; i < themes.themes.length; i++) {

      var theme = themes.themes[i];

      var themeOption = document.createElement('option');
      themeOption.innerHTML = theme.label;

      if (theme.id === localStorage.selectedTheme) {
        themeOption.selected = true;
      }

      themeSelector.appendChild(themeOption);

    }

    themeSelector.onchange = function() {

      if (!themeSelector.selectedIndex) {

        if (localStorage.selectedTheme) {
          delete localStorage.selectedTheme;
          themeLoader.load();
        }

        return;
      }

      var selectedTheme = themes.themes[themeSelector.selectedIndex - 1];

      if (selectedTheme.id === localStorage.selectedTheme) {
        return;
      }

      localStorage.selectedTheme = selectedTheme.id;

      themeLoader.load();

    };

    if (themes.addedTheme) { themes.addedTheme.remove(); }
    themes.addedTheme = null;
  }

  for (var i = 0; i < themes.themes.length; i++) {
    var theme = themes.themes[i];

    if (theme.id === localStorage.selectedTheme) {
      themes.addedTheme = theme.element;

      if (themes.customCss && themes.customCss.parentNode) {
        themes.customCss.remove();
      }

      // Entries without a .file have no element (see the guard above).
      if (theme.element) { document.head.appendChild(theme.element); }
    }
  }

};

themes.init();
